<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Add New Goods/Services</h4>
                        <h6 class="card-subtitle">Please keep your profile information always current in order to help you when you contact us.</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body card-blue">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="category">Category</label>
                                <div class="col-sm-6">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('category')}"
                                                 class="form-control"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :internal-search="false"
                                                 :options="categories"
                                                 @search-change="filterCategory"
                                                 data-vv-as="Category"
                                                 placeholder="Search Category"
                                                 id="category"
                                                 name="category"
                                                 v-model="goodsServices.category"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('category')">{{ errors.first('category') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="name">Name</label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('name')}"
                                           class="form-control"
                                           data-vv-as="name"
                                           id="name"
                                           name="name"
                                           placeholder="Goods/Services Name"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="goodsServices.name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('name')">{{ errors.first('name') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="variety">Variety</label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('variety')}"
                                           class="form-control"
                                           data-vv-as="Variety"
                                           id="variety"
                                           name="variety"
                                           placeholder="Goods/Services Variety"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="goodsServices.variety"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('variety')">{{ errors.first('variety') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="native">Native Name</label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('native')}"
                                           class="form-control"
                                           data-vv-as="Native"
                                           id="native"
                                           name="native"
                                           placeholder="Goods/Services Native Name"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="goodsServices.native"
                                           v-validate="">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('native')">{{ errors.first('native') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="description">Description</label>
                                <div class="col-sm-6">
                                    <textarea :class="{'is-invalid': submitted && errors.has('description')}"
                                              class="form-control"
                                              data-vv-as="description"
                                              id="description"
                                              name="description"
                                              placeholder="Goods/Services Description"
                                              rows=7
                                              v-model="goodsServices.description"
                                              v-validate="">
                                    </textarea>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('description')">{{ errors.first('description') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="units">Unit</label>
                                <div class="col-sm-6">
                                    <div :class="{'is-invalid': submitted && !goodsServices.unit_id }" class="form-control p-0-0">
                                        <unit-select @unit-select="setUnit"
                                                     id="units"
                                                     data-vv-as="unit"
                                                     ref="reference"
                                                     v-model="goodsServices.unit_id"
                                                     v-validate="'required'">
                                        </unit-select>
                                    </div>
                                    <div class="invalid-feedback" v-if="submitted && !goodsServices.unit_id">The Unit field is required</div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="rate">Rate</label>
                                <div class="col-sm-6 input-group">
                                    <input :class="{'is-invalid': submitted && errors.has('rate')}" class="form-control"
                                           data-vv-as="rate"
                                           id="rate"
                                           name="rate"
                                           placeholder="Rate"
                                           step="any"
                                           style="height: 42px;"
                                           type="number"
                                           v-model="goodsServices.rate"
                                           v-validate="'required'">
                                    <div class="input-group-append" v-if="goodsServices.rate">
                                        <span class="input-group-text text-info">
                                            {{currentOrg.currency_symbol}}{{goodsServices.rate}}/{{goodsServices.unit_symbol}}
                                        </span>
                                    </div>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('rate-form.rate')">{{ errors.first('rate-form.rate') }}</div>
                                </div>
                            </div>

                            <div class="form-group row" v-bind:key="index" v-for="(row, index) in goodsServices.props">
                                <label :for="'goodsService_id'+index" class="col-sm-3 text-right control-label col-form-label" v-if="index === 0">Property</label>
                                <label class="col-sm-3" v-if="index > 0"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('propname'+index)}"
                                           :name="'propname'+index"
                                           class="form-control"
                                           data-vv-as="propname"
                                           placeholder="Property Name"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="row.key"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('propname'+index)">{{ errors.first('propname'+index) }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('propval'+index)}"
                                           :name="'propval'+index"
                                           class="form-control"
                                           data-vv-as="propval"
                                           placeholder="Property Description"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="row.value"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('propval'+index)">{{ errors.first('propval'+index) }}</div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="form-group button-group">
                                        <button @click="addRow()" class="btn btn-success" style="height: 40px;" type="button" v-if="index === goodsServices.props.length - 1"><i
                                                class="fa fa-plus"></i>
                                        </button>
                                        <button @click="removeRow(index)" class="btn btn-danger" style="height: 40px;" type="button" v-else><i class="fa fa-minus"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import UnitSelect from "../../../../common/UnitSelect";
    import Multiselect from "vue-multiselect";
    import categories from "@/data/commodityCatagories";

    // const categories = [
    //           {
    //               "name": "Old",
    //               "value": "OLD"
    //           },
    //           {
    //               "name": "Service",
    //               "value": "SERVICE"
    //           },
    //           {
    //               "name": "Vegetables",
    //               "value": "VEGETABLES"
    //           },
    //           {
    //               "name": "Fruits",
    //               "value": "FRUITS"
    //           },
    //           {
    //               "name": "Dry Fruits",
    //               "value": "DRY_FRUITS"
    //           },
    //           {
    //               "name": "Food Grains",
    //               "value": "FOOD_GRAIN"
    //           },
    //           {
    //               "name": "Pulses",
    //               "value": "PULSES"
    //           },
    //           {
    //               "name": "Processed Items",
    //               "value": "PROCESSED_ITEMS"
    //           },
    //           {
    //               "name": "Spices",
    //               "value": "SPICES"
    //           },
    //           {
    //               "name": "Dairy",
    //               "value": "DAIRY"
    //           },
    //           {
    //               "name": "Edible Oils",
    //               "value": "EDIBLE_OILS"
    //           },
    //           {
    //               "name": "Salt Sugar Jaggery",
    //               "value": "SALT_SUGAR_JAGGERY"
    //           },
    //           {
    //               "name": "Beverages",
    //               "value": "BEVERAGES"
    //           },
    //           {
    //               "name": "Exotic",
    //               "value": "EXOTIC"
    //           },
    //           {
    //               "name": "Non Veg",
    //               "value": "NON_VEG"
    //           }
    //       ];

    export default {
        name: "AddPurchaseGoodsServices",
        components: {UnitSelect, Multiselect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                categories: [],
                goodsServices: {
                    category: null,
                    name: null,
                    variety: null,
                    native: null,
                    description: null,
                    unit_id: null,
                    unit_symbol: "",
                    rate: null,
                    props: [{
                        key: null,
                        value: null
                    }]
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                this.$refs.reference.unit = {
                    "id": null,
                    name: null,
                    "symbol": null,
                };
            },
            setUnit(e) {
                this.goodsServices.unit_id     = e.id;
                this.goodsServices.unit_symbol = e.symbol;
            },
            addRow() {
                this.goodsServices.props.push({
                    key: null,
                    value: null
                });
            },
            removeRow(index) {
                this.goodsServices.props.splice(index, 1);
            },
            async save() {
                try {
                    let payload = {
                        ...this.goodsServices,
                        category: this.goodsServices.category.value
                    };
                    let {data}  = await this.$http.put(`/express/${this.currentOrg.express_id}/purchases/goodsservices/`, payload);
                    this.$toastr('success', 'New Goods/Services has been added successfully.', 'Goods/Services Added');
                    this.$router.push({name: "viewpurchasegoodsservices", params: {goodsservicesid: data.goodsservicesid}});
                } catch(e) {
                    $(".preloader").fadeOut();
                }
            },
            handleSubmit() {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                });
            },
            reset() {
                this.submitted            = false;
                this.goodsServices        = {
                    name: "",
                    description: "",
                    unit_id: null,
                    rate: null
                };
                this.$refs.reference.unit = {
                    "id": null,
                    name: null,
                    "symbol": null,
                }
            },
            filterCategory(search) {
                this.categories = _.filter(categories, (c) => {
                    return c.name.toUpperCase().indexOf(search.toUpperCase()) != -1;
                });
            }
        }
    }
</script>

<style scoped>

</style>
